import sliderPerson from '../../../../../../src/js/modules/sliderPerson';

window.addEventListener('load', () => {
    sliderPerson.init();
});
